import { render, staticRenderFns } from "./SorItemDetailDialog.vue?vue&type=template&id=087b05aa"
import script from "./SorItemDetailDialog.vue?vue&type=script&lang=js"
export * from "./SorItemDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./SorItemDetailDialog.vue?vue&type=style&index=0&id=087b05aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports